<template>
  <div>
    <LayerMeasureLineLines
      :sourceId="geojson.data.id"
      :source="geojson"
      layerId="measure-line-lines"
    />
    <LayerMeasureLinePoints
      :sourceId="geojson.data.id"
      :source="geojson"
      layerId="measure-line-points"
    />
  </div>
</template>

<script>
import LayerMeasureLineLines from './LayerMeasureLineLines.vue'
import LayerMeasureLinePoints from './LayerMeasureLinePoints.vue'
import { length } from '@turf/turf'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { RESET_CURRENT_MEASUREMENT, SET_CURRENT_MEASUREMENT } from '@/store/mutation-types'

export default {
  name: 'LayerMeasureLine',
  components: {
    LayerMeasureLineLines,
    LayerMeasureLinePoints
  },
  data() {
    return {
      geojson: {
        type: 'geojson',
        data: {
          id: 'measure-line-source',
          type: 'FeatureCollection',
          features: []
        }
      },
      linestring: {
        id: 'measure-line-linestring',
        type: 'Feature',
        geometry: {
          type: 'LineString',
          coordinates: []
        }
      },
      turfLength: length
    }
  },
  computed: {
    ...mapGetters({
      isMeasurementActive: 'isMeasurementActive'
    }),
    ...mapState({
      currentTool: (state) => state.currentTool
    })
  },
  watch: {
    currentTool(newTool, old) {
      if (!this.isMeasurementActive || old === 'linemeasurement') {
        this.geojson.data.features = []
        this.linestring.geometry.coordinates = []
      }
    }
  },
  beforeUnmount() {
    this.resetCurrentMeasurement()
  },
  methods: {
    handleClick(event) {
      const features = this.$store.map.queryRenderedFeatures(event.point, {
        layers: ['measure-line-points']
      })
      if (this.geojson.data.features.length > 1) this.geojson.data.features.pop()

      this.resetCurrentMeasurement()
      if (features.length) {
        const id = features[0].properties.id
        this.geojson.data.features = this.geojson.data.features.filter(function (point) {
          return point.properties.id !== id
        })
      } else {
        const point = {
          type: 'Feature',
          geometry: {
            type: 'Point',
            coordinates: [event.lngLat.lng, event.lngLat.lat]
          },
          properties: {
            id: String(new Date().getTime())
          }
        }
        this.geojson.data.features.push(point)
      }
      if (this.geojson.data.features.length > 1) {
        this.linestring.geometry.coordinates = this.geojson.data.features.map(function (point) {
          return point.geometry.coordinates
        })
        this.geojson.data.features.push(this.linestring)
        this.setCurrentMeasurement({
          currentMeasurement: this.turfLength(this.linestring, {
            units: 'meters'
          })
        })
      }
      if (this.$store.map.getSource('measure-line-source') && this.geojson.data.features.length) {
        this.$store.map.getSource('measure-line-source').setData(this.geojson.data)
      }
    },
    handleMousemove(event) {
      if (this.isMeasurementActive && this.currentTool === 'linemeasurement') {
        let features = this.$store.map.queryRenderedFeatures(event.point, {
          layers: ['measure-line-points']
        })
        this.$store.map.getCanvas().style.cursor = features.length ? 'pointer' : 'crosshair'
      }
    },
    ...mapMutations({
      resetCurrentMeasurement: RESET_CURRENT_MEASUREMENT,
      setCurrentMeasurement: SET_CURRENT_MEASUREMENT
    })
  }
}
</script>
